<template>
  <div class="next-save__buttons">
    <mds-button
      v-if="displayedNextButton"
      icon-right="angle-right"
      variation="secondary"
      id="check-missing-fields"
      :disabled="disabledNextButton"
      @click="$emit('next-step', activeStep)"
    >
      {{ translate('scheduler.modal.next.button') }}
    </mds-button>
    <div v-else class="scheduler-modal__save-buttons">
      <mds-button
        variation="primary"
        :disabled="disableButtons"
        @click="$emit('save', false)"
      >
        {{ translate(saveOrEditLabel) }}
      </mds-button>
      <mds-button
        variation="primary"
        icon="caret-down"
        id="triger-save-button"
        :disabled="disableButtons"
        @click="toggle = !toggle"
      />
      <mds-popover
        class="scheduler-modal__popover"
        triggered-by="triger-save-button"
        v-model="toggle"
        :position="['top-left']"
      >
        <mds-list-group class="scheduler-modal__popover-options" size="small">
          <mds-list-group-item
            :text="translate(saveAndScheduleLabel)"
            @click.native="onSaveClick"
          />
        </mds-list-group>
      </mds-popover>
    </div>
  </div>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsPopover from '@mds/popover'
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'NextSaveButton',
  components: {
    MdsButton,
    MdsPopover,
    MdsListGroup,
    MdsListGroupItem,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    activeStep: {
      type: Number,
      default: 0,
    },
    editedFeed: {
      type: Object,
      default: undefined,
    },
    disabledNextButton: Boolean,
    disabledSaveButtons: Boolean,
    disabledEditButton: Boolean,
  },
  data() {
    return {
      defaultConfig,
      toggle: false,
    }
  },
  computed: {
    disableButtons() {
      if (this.editedFeed) {
        return this.disabledSaveButtons || !this.disabledEditButton
      }
      return this.disabledSaveButtons
    },
    saveOrEditLabel() {
      return !this.editedFeed
        ? 'scheduler.modal.save.button'
        : 'scheduler.modal.edit.button'
    },
    saveAndScheduleLabel() {
      return !this.editedFeed
        ? 'scheduler.modal.saveandschedule.button'
        : 'scheduler.modal.editandschedule.button'
    },
    displayedNextButton() {
      return this.activeStep !== 3
    },
  },
  methods: {
    onSaveClick() {
      this.$emit('save', true)
      this.toggle = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.scheduler-modal__popover {
  height: $mds-space-4-x + $mds-space-half-x;
  padding: 0;
  width: auto;
  z-index: 1000;
  &::v-deep > [class^='mds-popover__content'] {
    margin-block-start: $mds-space-three-quarter-x;
    ul li span div span:last-of-type {
      padding: 0 $mds-space-1-x;
    }
  }
  &-options {
    [class^='mds-list-group-item'] {
      cursor: pointer;
      :hover {
        background-color: #eff5ff;
      }
    }
  }
}
</style>
